export default {
  title: 'Secreto de firma del webhook',
  warning: 'Guarda este secreto ahora; no volverá a mostrarse. Úsalo para verificar el encabezado X-Webhook-Signature.',
  done: 'Listo',
};
